import { render, staticRenderFns } from "./FavoritesFilledIcon.vue?vue&type=template&id=f4192d12"
import script from "./FavoritesFilledIcon.vue?vue&type=script&lang=js"
export * from "./FavoritesFilledIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports